import userIcon from "../../stories/assets/user.png";
import cartIcon from "../../stories/assets/shopping-cart.svg";
import helpCircleIcon from "../../stories/assets/help-circle.svg";
import Logo from "../../stories/assets/Logo.png";
import Filter from "../../stories/assets/filter.png";
import Star from "../../stories/assets/Star.png";
import ActiveStar from "../../stories/assets/ActiveStar.png";
import Lady from "../../stories/assets/Lady.png";
import ChevronDown from "../../stories/assets/chevron-down.png";
import CalendarICon from "../../stories/assets/calendar.png";
import Marie from "../../stories/assets/Marie.png";
import ProfileImg from "../../stories/assets/Marie2.png";
import PlusCircle from "../../stories/assets/PlusCircle.png";
import Trash from "../../stories/assets/trash.png";
import Pin from "../../stories/assets/Pin.png";
import GuestImg from "../../stories/assets/userbig.png";
import Pin2 from "../../stories/assets/Pin2.png";
import AboutImage from "../../stories/assets/About.jpg";
import arrowLeft from "../../stories/assets/arrowLeft.png";
import imgA from "../../stories/assets/imgA.png";
import checkCircle from "../../stories/assets/check-circle.png";
import visa from "../../stories/assets/visa.png";
import paypal from "../../stories/assets/paypal.png";
import Home from "../../stories/assets/Home.png";
import Home2 from "../../stories/assets/Home2.png";
import Master from "../../stories/assets/Master.png";
import Pencil from "../../stories/assets/pencil.png";
import Symbol from "../../stories/assets/Symbol.png";
import Card from "../../stories/assets/Card.png";
import Truck from "../../stories/assets/truck.png";
import Menu from "../../stories/assets/Menu.svg";
import Menu2 from "../../stories/assets/Menu2.svg";
import MenuNormal from "../../stories/assets/MenuNormal.svg";
import Menu2Normal from "../../stories/assets/Menu2Normal.svg";
import user from "../../stories/assets/user2.png";
import greenCheckCircle from "../../stories/assets/greenCheckCircle.png";
import redCheck from "../../stories/assets/redCheck.jpg";
import ChevronRight from "../../stories/assets/ChevronRight.png";
import notFound from "../../stories/assets/notfound.png";
import Revolut from "../../stories/assets/Revolut.png";
import MessagingIcon from "../../stories/assets/message.jpg";

export const ICONPATH = {
  userIcon,
  cartIcon,
  helpCircleIcon,
  Logo,
  Home,
  Home2,
  user,
  greenCheckCircle,
  Filter,
  ChevronRight,
  Menu,
  MenuNormal,
  Menu2,
  MessagingIcon,
  Menu2Normal,
  notFound,
  Star,
  ActiveStar,
  AboutImage,
  Lady,
  CalendarICon,
  ChevronDown,
  Marie,
  PlusCircle,
  Trash,
  Truck,
  redCheck,
  Pencil,
  ProfileImg,
  Pin,
  Pin2,
  Symbol,
  Card,
  GuestImg,
  arrowLeft,
  imgA: imgA,
  checkCircle,
  visa: visa,
  paypal: paypal,
  Master: Master,
  Revolut: Revolut,
};

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
export const WS_BASE_URI = (process.env.REACT_APP_WS_BASE_URI || "").replace(/\/+$/, "");
export const BASE_URL_1 = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
// If IMAGE_BASE_URI is empty, don't add any prefix (paths like "/media/..." resolve as relative).
// If it has a value, strip trailing slash so `${IMAGE_BASE_URI}${path}` never produces "//".
export const IMAGE_BASE_URI = (process.env.REACT_APP_IMAGE_BASE_URI || "").replace(/\/+$/, "");
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

